import React from 'react';
import { Provider } from 'react-redux';
import { store } from '@/stores/store';
import { SyncMachineProvider } from '@/contexts/sync-machine-context';

interface AppProviderProps {
  children: React.ReactNode;
}

/**
 * Main application provider that wraps all providers needed by the app.
 * Currently includes:
 * - Redux store provider
 * - SyncMachineProvider (makes sync state machines available via hooks)
 *
 * Future providers can be added here (e.g., Theme, Auth, Vault Settings, etc.)
 */
export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
  return (
    <Provider store={store}>
      <SyncMachineProvider>
        {children}
      </SyncMachineProvider>
    </Provider>
  );
};

export default AppProvider;